import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import uuid from 'uuid'
import { get } from 'lodash'
import { FormattedMessage } from 'react-intl'
import { FormattedDate } from 'components/intl'
import { Modal } from 'containers/misc'
import { TaskApprove } from 'containers/forms/tasks'
import { Table, Data } from 'components/layout/Table'
import { Button, ButtonGroup } from 'components/misc'

import MODALS from 'constants/modals'

import { tasks as tasksLayout } from 'constants/layout'
import {
  apiConfiguration,
  apiCommon,
  apiCodeLists,
  apiTasksRegistrationParticipants,
  apiParticipants,
  apiAwards,
  apiTasksWWCUpdate
} from 'helpers/decorators/api'
import { modal, notification } from 'redux/modules/app'
import { meta, tableCommon } from 'helpers/decorators'
import TaskAssessorEdit from '../../forms/tasks/TaskAssessorEdit/TaskAssessorEdit'
import { CONFIGURATION_KEYS } from '../../../constants/enums'
import TaskReturn from '../../forms/tasks/TaskReturn/TaskReturn'
import { Link } from 'react-router-dom'
import config from '../../../config'

@meta({
  title: 'Tasks - WWC',
  intlKey: 'pageTitle.tasks_wwc'
})
@apiConfiguration({
  getValues: [
    CONFIGURATION_KEYS.manageAssessors.id
  ],
  inOrganizationDetail: true
})
@apiCommon({
  countries: true,
})
@apiCodeLists(['titles', 'phoneTypes', 'assessorReasonsOfDeletionTypes'])
@apiTasksRegistrationParticipants({
  participants: true
})
@apiParticipants({
  updateTasks: true
})
@apiTasksWWCUpdate({
  wwcUpdateTasks: true,
  updateTasks: true,
  useCommonLimit: true
})
@apiAwards({
  updateRegistrationTasks: true
})
@tableCommon()
@connect(null, { modal, notification })
class TasksWWCUpdate extends Component {
  static propTypes = {
    tasksWWCUpdate: PropTypes.object.isRequired,
    modal: PropTypes.func.isRequired,
    setAssessorTasksParams: PropTypes.func,
    setCommonLimit: PropTypes.func,
    configuration: PropTypes.object.isRequired,
    codeLists: PropTypes.object.isRequired,
    common: PropTypes.object.isRequired,
    onApproveWWCUpdate: PropTypes.func,
    onReturnWWCUpdate: PropTypes.func,
    onApproveWWCUpdateWithoutFile: PropTypes.func,
    onReturnWWCUpdateWithoutFile: PropTypes.func
  }

  state = {
    wwcUpdate: null,
  }

  key = uuid.v1()

  handleApproveModal = wwcUpdate => {
    this.setState({ wwcUpdate }, () => {
        this.props.modal(`modal-approve-${this.key}`)
    })
  }
  handleReturnModal = wwcUpdate => {
    this.setState({ wwcUpdate }, () => {
        this.props.modal(`modal-return-${this.key}`)
    })
  }
  handleApproveWWCUpdate = () => {

    const assessorFile = get(this.state.wwcUpdate, 'assessorFile')

    if(assessorFile !== null){
      this.props.onApproveWWCUpdate(get(this.state.wwcUpdate, 'assessor.id'))
    } else {
      this.props.onApproveWWCUpdateWithoutFile(get(this.state.wwcUpdate, 'assessor.id'))
    }
  }

  handleReviseWWCUpdate = () => {

    const assessorFile = get(this.state.wwcUpdate, 'assessorFile')

    if(assessorFile !== null){
      this.props.onReturnWWCUpdate(get(this.state.wwcUpdate, 'assessor.id'))
    } else {
      this.props.onReturnWWCUpdateWithoutFile(get(this.state.wwcUpdate, 'assessor.id'))
    }
  }

  handleEditModal = wwcUpdate => {
    this.setState({ wwcUpdate }, () => {
      this.props.modal(MODALS.ASSESSOR_REGISTRATION_EDIT)
    })
  }

  render() {
    const {
      tasksWWCUpdate: { loading, list, offset, limit, pages, sort },
      setAssessorTasksParams,
      setCommonLimit,
      configuration,
      codeLists,
      common,
    } = this.props

    const isAssessorManagementEnabled = configuration && configuration.values[CONFIGURATION_KEYS.manageAssessors.id]?.booleanValue

    return (
      <div>
        <Table
          loading={loading}
          length={list.length}
          offset={offset}
          limit={limit}
          onSetLimit={setCommonLimit}
          pages={pages}
          sort={sort}
          ths={tasksLayout.wwcUpdateTable}
          setParams={setAssessorTasksParams}
        >
          <Data>
            {list.map((wwcUpdate, i) => {
              const assessor = get(wwcUpdate, 'assessor')
              const person = get(assessor, 'person')
              const wwcFile = get(wwcUpdate, 'assessorFile')

              return (<tr key={i}>
                <td>
                  <Link to={`${config.publicPath}/organizations/${get(assessor, 'organization.id')}/assessors/${get(assessor, 'person.id')}/detail`}>
                    {get(assessor, 'id')}
                  </Link>
                </td>
                <td>{get(person, 'firstName')}</td>
                <td>{get(person, 'lastName')}</td>
                <td>{get(person, 'email')}</td>
                <td>{wwcFile ? get(wwcFile, 'childProtectionNumber') : get(wwcUpdate, 'childProtectionNumber')}</td>
                <td>
                  <FormattedDate
                    value={wwcFile ? get(wwcFile, 'childProtectionExpirationDate') : get(wwcUpdate, 'childProtectionExpirationDate')}
                  />
                </td>
                <td>
                  <Button
                    style={{ marginLeft: 10 }}
                    onClick={() => this.handleEditModal(wwcUpdate)}
                    tiny
                    secondary
                  >
                    <FormattedMessage
                      id="button.confirm"
                      defaultMessage="Confirm"
                    />
                  </Button>
                </td>
                <td>
                  <ButtonGroup>
                    <Button
                      onClick={() =>
                        this.handleApproveModal(wwcUpdate)
                      }
                      tiny
                    >
                      <FormattedMessage
                        id="button.approve"
                        defaultMessage="Approve"
                      />
                    </Button>
                    <Button
                      onClick={() =>
                        this.handleReturnModal(wwcUpdate)}
                      intlKey="button.revise"
                      tiny
                      secondary
                    >
                      Revise
                    </Button>
                  </ButtonGroup>
                </td>
              </tr>)
            })}
          </Data>
        </Table>
        <Modal id={MODALS.ASSESSOR_REGISTRATION_EDIT} customActions large>
          <TaskAssessorEdit
            registration={this.state.wwcUpdate}
            forWWCUpdate
            isAssessorManagementEnabled={isAssessorManagementEnabled}
            codeLists={codeLists}
            common={common}
            onEditSubmit={() => {}}
            onDeleteSubmit={() => {}}
          />
        </Modal>
        <Modal id={`modal-approve-${this.key}`} customActions>
          <TaskApprove
            approve={this.handleApproveWWCUpdate}
            id={get(this.state.wwcUpdate, 'assessor.id')}
            modal={this.props.modal}
            title="Approve WWC update"
            intlKey="tasks.approve_wwc_update"
            isWWCUpdate
          />
        </Modal>
        <Modal id={`modal-return-${this.key}`} customActions>
          <TaskReturn
            returnTask={this.handleReviseWWCUpdate}
            id={get(this.state.wwcUpdate, 'assessor.id')}
            title="Revise WWC update"
            intlKey="tasks.return_wwc_update"
            noNote
          />
        </Modal>
      </div>
    )
  }
}

export default TasksWWCUpdate
